export const ALL_PATIENTS_PAGE = "patients";
export const ALL_PATIENTS_PATH = ALL_PATIENTS_PAGE;
export const PATIENT_DETAILS_PAGE = ":patientId";
export const PATIENT_DETAILS_PATH =
  `${ALL_PATIENTS_PATH}/${PATIENT_DETAILS_PAGE}` as const;
